import { z } from 'zod';

// Firma v globálnom registri Marstein Radar — NIE org-scoped ako v CRM Marstein (companies
// je tu jeden zdieľaný dataset všetkých firiem, nie dáta per zákazník). Watchlist
// (Blok 1) bude org/user-scoped nad týmto zdieľaným záznamom.
export const companySchema = z.object({
  id: z.string().uuid(),
  ico: z.string(),
  name: z.string().nullable(),
  dic: z.string().nullable(),
  icDph: z.string().nullable(),
  address: z
    .object({
      street: z.string().optional(),
      city: z.string().optional(),
      zip: z.string().optional(),
      country: z.string().optional(),
    })
    .nullable(),
  registrySyncedAt: z.string().nullable(),
  // Týž. 19 — presný NACE kód (hlavná činnosť), enrichment z RPO SQL dumpu (nie
  // z bežného sync API) — chýba pre firmy bez zaznamenanej hlavnej činnosti alebo
  // pridané po dátume enrichmentu, viď docs/CURRENT.md.
  naceCode: z.number().nullable(),
  naceName: z.string().nullable(),
  createdAt: z.string(),
  updatedAt: z.string(),
});
export type Company = z.infer<typeof companySchema>;
